import { FetchResult, gql } from 'apollo-boost';
import { removeFields } from '../../../helpers/common-helpers';
import { IUserGroup } from '../../../models/user-group';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const QUERY = gql`
    query GetPrevUserGroup($user_group_uid: String!) {
        user_group_get_prev_group(user_group_uid: $user_group_uid) {
            uid,
            title,
        }
    }
`;

export async function getPrevUserGroup(uid?: string): Promise<IUserGroup | undefined> {
    if(!uid) {
        return undefined;
    }

    const result: FetchResult<{ user_group_get_prev_group: IUserGroup | null }> = await graphqlClient.query({
        query: QUERY,
        variables: { user_group_uid: uid },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    const group = result.data.user_group_get_prev_group;
    return group ? removeFields(group, ['__typename']) : undefined;
}
